import { NavLink } from 'react-router-dom';
import { PawPrint, ClipboardList, Package, CalendarDays, HeartPulse } from 'lucide-react';
import { ROUTES } from '../../config/constants';

// 5 tabs: con max-w-md y px-2 py-2 el ancho por tab queda ~80px. Las labels
// más largas ("Calendario", "Inventario", 10 chars × ~6.5px en text-[11px])
// caben justas. Si en el futuro la cosa se aprieta más, alternativa:
// agrupar Bitácora + Inventario bajo un "Más" o cambiar a text-[10px].
const NAV_ITEMS = [
  { to: ROUTES.PETS,      label: 'Mascotas',   icon: PawPrint },
  { to: ROUTES.CALENDAR,  label: 'Calendario', icon: CalendarDays },
  { to: ROUTES.HEALTH,    label: 'Salud',      icon: HeartPulse },
  { to: ROUTES.LOGS,      label: 'Bitácora',   icon: ClipboardList },
  { to: ROUTES.INVENTORY, label: 'Inventario', icon: Package },
];

/**
 * Navegación inferior fija. NavLink resuelve el estado activo automáticamente.
 * El padding-bottom safe-area protege el contenido del home indicator en iOS.
 */
const BottomNav = () => {
  return (
    <nav
      aria-label="Navegación principal"
      className="fixed inset-x-0 bottom-0 z-30 border-t border-slate-200 bg-white/95 backdrop-blur-md pb-safe"
    >
      <ul className="mx-auto flex max-w-md items-center justify-around px-2 py-2">
        {NAV_ITEMS.map(({ to, label, icon: Icon }) => (
          <li key={to} className="flex-1">
            <NavLink
              to={to}
              end={to === ROUTES.PETS}
              className={({ isActive }) =>
                [
                  'flex flex-col items-center gap-0.5 rounded-xl px-3 py-2 transition-colors',
                  isActive
                    ? 'text-brand-700'
                    : 'text-slate-500 hover:text-slate-700 active:bg-slate-100',
                ].join(' ')
              }
            >
              {({ isActive }) => (
                <>
                  <Icon
                    className="h-6 w-6"
                    strokeWidth={isActive ? 2.4 : 1.8}
                    aria-hidden="true"
                  />
                  <span className="text-[11px] font-medium">{label}</span>
                </>
              )}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default BottomNav;